import React from 'react';

interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownProps {
  id?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: DropdownOption[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  name?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  id,
  value,
  onChange,
  options,
  placeholder,
  disabled = false,
  className = '',
  required = false,
  name,
}) => {
  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      required={required}
      className={`block w-full rounded-md border-gray-300 shadow-sm 
        focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50
        disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed
        text-base ${className}`}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
